import React from 'react';
import ProgressBar from '../progress-bar';

// Full-page wait for a background job. `children` takes any action the page
// needs alongside it, such as a manual refresh.
const PageProgress = ({
    progress = 0,
    text,
    iconSrc = "/images/icon/lunch.svg",
    children,
}) => (
    <div className="page-progress">
        <div className="page-progress-content">
            <img src={iconSrc} alt="" className="page-progress-icon" />
            <ProgressBar progress={progress} text={text} />
            {children}
        </div>
    </div>
);

export default PageProgress;
